import { api } from '../ajax';
export default {
    namespaced: true,
    state: {
        request: false,
        stores: []
    },
    mutations: {
        REQUEST(state, value){
            state.request = value
        }
    },
    actions: {
        list({commit}) {
            commit('REQUEST', true)
            return new Promise((resolve, reject) => {
                api.get('/store_list')
                .then(response => {
                    commit('REQUEST', false)
                    resolve(response.data)
                })
                .catch(error => {
                    commit('REQUEST', false)
                    reject(error.response)
                })
            })
        }
    },
    getters: {
        get_stores: state => { return state.stores }
    }
}